import { useQuery } from '@tanstack/react-query';
import { invitationsService } from '../api/invitations.service';
import { MY_INVITATIONS_KEYS } from './queryKeys';

/**
 * Fetches the current user's pending invitations.
 *
 * @remarks
 * - Does NOT require activeOrganizationId — invitations are user-scoped,
 *   not org-scoped, so the endpoint works before org selection.
 * - staleTime 5 min: invitations change rarely and do not need aggressive revalidation.
 */
export function useMyInvitations() {
  return useQuery({
    queryKey: MY_INVITATIONS_KEYS.all,
    queryFn: ({ signal }) => invitationsService.getMyInvitations(signal),
    staleTime: 300_000,
  });
}
